import I18n from '@/modules/i18n';
import Templates from '@/pages/events/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  gridyOptions() {
    return {
      headers: [
        { name: I18n.t('activerecord.attributes.user.name'), value: 'users.name' },
        { name: I18n.t('activerecord.attributes.user.email'), value: 'users.email' },
        { name: I18n.t('activerecord.attributes.editor.promoter_role_id'), value: 'editors.promoter_role_id' },
        { name: I18n.t('action.other'), value: '' },
      ],

      sortName: 'users.name',
      template: Templates.editors.gridy,
    };
  }
}
